/**
 * Phase 3 - Portuguese translations module
 */
import enBase from './en.js';
import { translationsPt } from '../../utils/translations/translations.pt.js';
import { plansTranslationsPt } from '../../utils/translations/plans/plansTranslations.pt.js';

const merged = { ...enBase, ...translationsPt, ...plansTranslationsPt };
export default merged;
